import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BoatOwnerComponent } from './boat-owner.component';
import { BoatOwnerResolve } from './boat-owner.resolve';
import { PortalComponent } from '../../portal.component';

@NgModule({
  imports: [RouterModule.forChild([])],
  exports: [RouterModule],
})
export class BoatOwnerRoutingModule {}
